<app-modal-container
  (changeStep)="onChangeStep($event)"
  [steps]="steps"
  (onUpdate)="_carregarModal()"
  [unidadeProdutiva]="unidadeProdutiva"
  [esconderAndamentoCertificacao]="
    esconderAndamentoCertificacao || !isStartEtapaVdpVar
  "
  (toggleModalStatus)="toggleModalStatus($event)"
  [loading]="loading"
  [perfilUsuario]="perfilUsuario"
>
  <ng-container *ngIf="modalAberto">
    <modal-etapa-vdp
      #modalEtapaVDP
      *ngIf="activeStepLabel === 'VDP'"
      [unidadeProdutiva]="unidadeProdutiva"
      (concluirEtapa)="onConcluiuEtapa()"
    ></modal-etapa-vdp>
    <modal-etapa-pcnc
      #modalEtapaPCNC
      *ngIf="activeStepLabel === 'PCNC'"
      [unidadeProdutiva]="unidadeProdutiva"
      (concluirEtapa)="onConcluiuEtapa()"
    ></modal-etapa-pcnc>
  </ng-container>
</app-modal-container>
